import { render, staticRenderFns } from "./ShimerLoader.vue?vue&type=template&id=1c71554d&"
import script from "./ShimerLoader.vue?vue&type=script&lang=js&"
export * from "./ShimerLoader.vue?vue&type=script&lang=js&"
import style0 from "./ShimerLoader.vue?vue&type=style&index=0&id=1c71554d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports